module.exports = __webpack_public_path__ + "static/media/onduline-logo.a7378ba5.svg";